import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../../assets/img/pcSearch.png'


const _hoisted_1 = { class: "searchList" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["onClick", "innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "searchResult"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["searchBtn", _ctx.topSearch?'hoverSearchBtn':'']),
    style: _normalizeStyle({'height':_ctx.searchHeight>0?(_ctx.searchHeight+'px'):'52px'}),
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleInputFocus && _ctx.handleInputFocus(...args)))
  }, [
    _createVNode(_component_el_input, {
      onBlur: _ctx.inputBlur,
      onInput: _ctx.inputChange,
      class: "searchText",
      onFocus: _ctx.inputFocus,
      modelValue: _ctx.inputValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
      onKeyup: _withKeys(_ctx.handleBack, ["enter","native"]),
      placeholder: "请输入关键字，搜索您想要查找的内容"
    }, {
      prefix: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createElementVNode("div", { style: {"width":"30px","height":"100%","display":"flex","align-items":"center"} }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "搜索"
          })
        ], -1)
      ]))]),
      _: 1
    }, 8, ["onBlur", "onInput", "onFocus", "modelValue", "onKeyup"]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      (_ctx.isHistory)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { style: {"font-size":"14px","color":"#999999","letter-spacing":"0","font-weight":"400","margin":"15px 0","padding":"0 0.5rem","box-sizing":"border-box"} }, "最近搜索", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchHistory, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                onClick: ($event: any) => (_ctx.handleSelectHistory(item)),
                key: i,
                class: "searchItem"
              }, _toDisplayString(item), 9, _hoisted_3))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchList, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                onClick: ($event: any) => (_ctx.handleSelectItem(item)),
                key: i,
                class: "searchItem",
                innerHTML: item.current.type==1?(item.current?.name):item.current.docDescribeUnformatted
              }, null, 8, _hoisted_5))
            }), 128)),
            (_ctx.searchList.length==0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, "未检测到搜索结果"))
              : _createCommentVNode("", true)
          ]))
    ], 512), [
      [_vShow, _ctx.showPopover&&(_ctx.searchHistory.length>0||_ctx.searchList.length>0)]
    ])
  ], 6))
}